import React from "react";
import "./navigation-list-item.scss";

import { faChevronRight, faExternalLinkSquareAlt } from "@fortawesome/free-solid-svg-icons";
import { GSButton, GSInfoGroup } from "golfstatus_react_components";

const NavigationListItem = (props) => {
  const { page } = props;
  const getPageDataGroup = () => {
    let item = [
      {
        fit: "stretch",
        sections: [
          {
            sectionItems: [
              { type: "primary no-wrap", value: page?.label },
              { type: "secondary", value: page?.details },
            ],
          },
        ],
      },
    ];
    if (page.isExternal) {
      item.push({ title: <GSButton buttonIcon={faExternalLinkSquareAlt} /> });
    }
    else{
      item.push({ title: <GSButton buttonIcon={faChevronRight} /> });
    }
    return item;
  };
  return (
    <navigation-list-item>
      <GSInfoGroup
        type="list-item separator selectable x-large-pad"
        dataGroups={getPageDataGroup()}
      ></GSInfoGroup>
    </navigation-list-item>
  );
};

export default NavigationListItem
